import {SUPER_ADMIN} from "../../../helpers/constants";
import CompanySelect from "../../Company/CompanySelect";
import {Button, FormGroup, Input} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import React from "react";

const PromoterSalesPointActiveDevicesControls = props => {
    const filterByVideoOwnerCompanies = props.authority === SUPER_ADMIN ? (
        <CompanySelect
            className="promoter-search-filter"
            lang={props.lang}
            defaultOptionText={I18n[props.lang].videoOwner}
            companyId={props.videoOwnerCompanyIdFilter}
            companies={props.companies}
            onCompanyChange={props.onFilterClick('videoOwnerCompanyIdFilter')}
        />) : null;
    const filterByContributorCompanies = props.authority === SUPER_ADMIN || props.company.types.includes('OPERATOR') ? (
        <CompanySelect
            className="promoter-search-filter"
            lang={props.lang}
            companyId={props.contributorCompanyIdFilter}
            companies={props.companies}
            onCompanyChange={props.onFilterClick('contributorCompanyIdFilter')}
        />) : null;

    return (
        <FormGroup>
            <Input
                className="promoter-search-filter"
                type="text"
                name="salesPointNameFilter"
                id="salesPointNameFilter"
                value={props.salesPointNameFilter}
                onChange={props.onFilterClick('salesPointNameFilter')}
                placeholder={I18n[props.lang].searchStore}
            />
            {filterByVideoOwnerCompanies}
            {filterByContributorCompanies}
            <Button
                className="mr-2"
                color="primary"
                type="button"
                onClick={props.getFiltered}
            >
                {I18n[props.lang].filter}
            </Button>
            <Button
                className="mr-2"
                color="primary"
                type="button"
                onClick={props.clearFilters}
            >
                {I18n[props.lang].resetFilters}
            </Button>
            <Button
                color={props.isCsvLoading ? "secondary" : "primary"}
                type="button"
                disabled={props.isCsvLoading}
                onClick={props.downloadCsv}
            >
                {props.isCsvLoading ?
                    <i className="fa fa-spinner fa-spin mr-2"/> : null} {I18n[props.lang].modal.downloadCsv}
            </Button>
        </FormGroup>
    )
}

export default PromoterSalesPointActiveDevicesControls;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterSalesPointActiveDevices/PromoterSalesPointActiveDevicesControls.js